import { render } from "./WildBookObserveCoordinates.vue?vue&type=template&id=34fbd04e&scoped=true&ts=true"
import script from "./WildBookObserveCoordinates.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveCoordinates.vue?vue&type=script&lang=ts"

import "./WildBookObserveCoordinates.vue?vue&type=style&index=0&id=34fbd04e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fbd04e"]])

export default __exports__